module.exports = "/_next/static/images/344da2ed03889696f7ba9b0ee6f75977-hero-belinda-mobile.jpg";